import React from 'react'
import { 
    SidebarContainer, 
    SideClose, 
    SideIcon, 
    SideLogo, 
    SideList, 
    SideItem 
} from './SidebarElements'

const Sidebar = ({isOpen, toggle}) => {
  return (
    <>
      <SidebarContainer isOpen={isOpen}>
        <SideClose>
            <SideLogo> Luimit </SideLogo>
            <SideIcon onClick={toggle}/>
        </SideClose>
        <SideList>
                
            <SideItem spy={true} offset={-100} smooth={true} duration={500} onClick={toggle} to="home">
                    Home
            </SideItem>

            <SideItem spy={true} offset={-100} smooth={true} duration={500} onClick={toggle} to="quem-somos">
                    Quem Somos
            </SideItem>

            <SideItem spy={true} offset={-100} smooth={true} duration={500} onClick={toggle} to="vinil">
                    Piscinas
            </SideItem>

            <SideItem spy={true} offset={-100} smooth={true} duration={500} onClick={toggle} to="ref">
                    Reformas
            </SideItem>

            <SideItem spy={true} offset={-100} smooth={true} duration={500} onClick={toggle} to="contatos">
                    Contatos
            </SideItem>

            <SideItem onClick={() => (window.location.href='#/portfolio')}>
                    Portfolio
            </SideItem>

        </SideList>
      </SidebarContainer>
    </>
  )
}

export default Sidebar